import { Injectable } from '@angular/core';
import { AppHttpClientService } from '../app-http-client.service';

export enum AudioProviders {
  Agora = 'agora',
  AntMedia = 'antmedia',
}

export class AudioControlConfig {
  providerName: AudioProviders;
  token: string;
}

@Injectable()
export class AudioControlService {
  constructor(private appHttpClient: AppHttpClientService) {}

  getAudioConfig(auctionId: string) {
    return this.appHttpClient.get<AudioControlConfig>('audio?auctionId=' + auctionId);
  }
}
